import { FC } from 'react';
import { SetArrType } from '.';
import { ButtonSection } from './AllFiltersSection';
import { ButtonIcon, FButton, FButtonWrapper, FModalWrapper } from './styles';

interface FilterObject {
  title: string;
  value: string;
}
interface Filter {
  title: string;
  type: string;
  array: FilterObject[];
  selectedArray: string[];
}

interface FilterButtonProps {
  selected: boolean;
  name: string;
  title: string;
  handleSetSelectedFilter: (f: string) => void; // Function for setting active filter
  filters: Filter[];
  handleSetArr: (type: SetArrType, b: string) => void;
  onClickApply: () => void;
  onClickClear: (type: string) => void;
}

const FilterButton: FC<FilterButtonProps> = ({
  selected,
  name,
  handleSetSelectedFilter,
  onClickApply,
  onClickClear,
  title,
}) => {
  const allFilters = name === 'allFilters';

  return (
    <FButtonWrapper $allFilters={allFilters}>
      <FButton $selected={selected} onClick={() => handleSetSelectedFilter(name)} $all={allFilters}>
        {title}
        {name === 'allFilters' && (
          <ButtonIcon>
            <span />
          </ButtonIcon>
        )}
      </FButton>
      {selected && (
        <FModalWrapper $open={selected && allFilters}>
          {!allFilters && (
            <ButtonSection
              data-testid={`filter-${name}`}
              onClickApply={onClickApply}
              onClickClear={onClickClear}
              name={name}
            />
          )}
        </FModalWrapper>
      )}
    </FButtonWrapper>
  );
};

export default FilterButton;
